export const addressDadataToBackendModel = (dadataResponse, indexFieldValue) => {
  if (dadataResponse && dadataResponse.data && !dadataResponse.data.postal_code && indexFieldValue){
    dadataResponse.data.postal_code = indexFieldValue;
  }

  return dadataResponse;
}
